import { render, staticRenderFns } from "./AddOrEditDialog.vue?vue&type=template&id=6bb6a8ba&scoped=true"
import script from "./AddOrEditDialog.vue?vue&type=script&lang=js"
export * from "./AddOrEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb6a8ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb6a8ba')) {
      api.createRecord('6bb6a8ba', component.options)
    } else {
      api.reload('6bb6a8ba', component.options)
    }
    module.hot.accept("./AddOrEditDialog.vue?vue&type=template&id=6bb6a8ba&scoped=true", function () {
      api.rerender('6bb6a8ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/org/components/orgGroup/AddOrEditDialog.vue"
export default component.exports